import { render } from "./v-multi-select.vue?vue&type=template&id=4eb703f6&scoped=true"
import script from "./v-multi-select.vue?vue&type=script&lang=js"
export * from "./v-multi-select.vue?vue&type=script&lang=js"

import "./v-multi-select.vue?vue&type=style&index=0&id=4eb703f6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb703f6"]])

export default __exports__